
const digest = '024e2cb74838dec85596a9630b7a7fa7c285f62aed7f2f8ffe079c5ddce5a211';
const classes = {"wrapper":"_wrapper_npze9_1"};
const css = `._wrapper_npze9_1 {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  height: 100%;
  font-family: "Rubik", sans-serif;
  margin: -24px -34px;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  